export const VARIABLE_COLORS = [
  '#00d9ff', // cyan (app accent)
  '#a78bfa', // purple
  '#f078be', // pink
  '#34c77b', // green
  '#ffc53d', // yellow
  '#ff9640', // orange
  '#3895ff', // blue
  '#acd23c', // lime
  '#ff5e5e', // red
  '#2dc8be', // teal
];

export const DEFAULT_VARIABLE_COLOR = VARIABLE_COLORS[0];

/** Display name for a variable whose value is saved on the document. */
export const DOC_VARIABLE_SOURCE_NAME = 'This document';

/** Display name for a doc row whose value is this mission's own copy. */
export const MISSION_VARIABLE_SOURCE_NAME = 'This mission';

/** Pick the first palette color not used yet (cycles once all are taken). */
export const nextVariableColor = (existing = []) => {
  const used = new Set(existing.map((v) => v.color));
  return VARIABLE_COLORS.find((c) => !used.has(c)) || VARIABLE_COLORS[existing.length % VARIABLE_COLORS.length];
};

export const generateVariableId = () =>
  `var-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

/** Names are case-insensitive; whitespace-trimmed. */
export const normalizeVariableName = (name) => String(name || '').trim();

export const nameKey = (name) => normalizeVariableName(name).toLowerCase();

export const variableNameKey = nameKey;
